import React, { FunctionComponent } from 'react'
import { UXComponent } from './uxComponent'
import { getComponentByType } from './componentRegistry'

export const UXComponentRenderer: FunctionComponent<UXComponent> = component => {
  const componentByType = getComponentByType()

  if (!componentByType[component.type]) {
    return null
  }

  return React.createElement(
    componentByType[component.type] as FunctionComponent<UXComponent>,
    component
  )
}
